<script lang="ts">
  import Tag from "@kontextwerk/web-sdk/ui/display/Tag.svelte"
  import type {
    OrganizationOnboardingStepSummary,
    OrganizationOnboardingSummaryItemStatus,
  } from "../../../../../../../../../../../../../../../../api/kehrblatt/organization-onboarding"

  let { summary = null }: { summary?: OrganizationOnboardingStepSummary | null } = $props()

  const statusLabel = (status: OrganizationOnboardingSummaryItemStatus) => {
    if (status === "ready") return "Bereit"

    if (status === "missing") return "Fehlt"

    if (status === "warning") return "Prüfen"

    return "Info"
  }

  const statusColor = (
    status: OrganizationOnboardingSummaryItemStatus,
  ): "green" | "red" | "yellow" | "neutral" => {
    if (status === "ready") return "green"

    if (status === "missing") return "red"

    if (status === "warning") return "yellow"

    return "neutral"
  }
</script>

{#if summary?.items?.length}
  <ul class="summary-list">
    {#each summary.items as item}
      <li>
        <div>
          <strong>{item.label}</strong>
          {#if item.detail}
            <span>{item.detail}</span>
          {/if}
        </div>
        <Tag
          tag={statusLabel(item.status)}
          color={statusColor(item.status)}
          variant={item.status === "neutral" ? "soft" : "solid"}
          smallVersion={true}
        />
      </li>
    {/each}
  </ul>
{:else if summary?.empty_label}
  <p class="empty">{summary.empty_label}</p>
{/if}

<style lang="less">
  .summary-list {
    display: flex;
    flex-direction: column;
    gap: 0.45rem;
    margin: 0;
    padding: 0;
    list-style: none;
  }

  li {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.8rem;
    border-bottom: 1px solid color-mix(in srgb, var(--text-100) 12%, transparent);
    padding-bottom: 0.45rem;
  }

  li:last-child {
    border-bottom: 0;
    padding-bottom: 0;
  }

  strong,
  span {
    display: block;
  }

  strong {
    color: var(--text-100);
    font-size: 0.92rem;
    line-height: 1.2;
  }

  span,
  .empty {
    color: color-mix(in srgb, var(--text-100) 64%, transparent);
    font-size: 0.84rem;
    line-height: 1.35;
  }

  .empty {
    margin: 0;
  }
</style>
